import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OptionComp } from '../OptionComp';
import { MileageLimitSetting, OtherSettingItem } from '@/types/system-setting';
import { formatCurrency } from '@/utils/formatNumber';
import MileageLimitComp from './MileageLimtComp';

export default observer(function OtherSettingList() {
    const { t } = useTranslation();

    // store
    const {
        generalStore: { otherSetting }
    } = useStore();

    // state
    const [mileageLimit, setMileageLimt] = useState<MileageLimitSetting | null>(null);
    const [dropOffSetting, setDropOff] = useState<OtherSettingItem | null>(null);

    // lifecycle
    useEffect(() => {
        if (otherSetting && Object.keys(otherSetting).length > 0) {
            const { mileageLimit, dropOff } = otherSetting;
            setMileageLimt(mileageLimit);
            if (dropOff && dropOff.length > 0) {
                setDropOff({ ...dropOff[0] });
            }
        }
    }, [otherSetting]);

    return (
        <>
            {
                mileageLimit && <MileageLimitComp mileageLimitSetting={mileageLimit} />
            }
            {
                dropOffSetting && (
                    <OptionComp
                        option={{
                            title: t('price_list.title_section.drop_off'),
                            textDecoration: t('price_list.text_decoration.drop_off'),
                            descriptionList: [t('sentences.drop_off_des_1'), t('sentences.drop_off_des_2')],
                            specialNote: [t('sentences.drop_off_note_1'), t('sentences.price_contain_tax')],
                            data: [
                                {
                                    fieldName: 'レンタルごとの料金',
                                    value: '',
                                    valueClass: 'hidden',
                                    fieldNameClass: '!col-span-full justify-center'
                                },
                                {
                                    fieldName: 'レンタルごとの料金',
                                    value: `${formatCurrency(dropOffSetting?.price)}円/1km`,
                                    valueClass: '!col-span-full',
                                    fieldNameClass: 'hidden'
                                }
                            ]
                        }}
                    />
                )
            }

        </>
    );
});
